import React, { Component, ComponentType } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { GarageKeyType } from "src/components/UserAccount/shared/GarageKey";
import { GarageRequestAccess } from "src/store/types/state";
import AccessGarage, { AccessGarageProps } from "./AccessGarage";
import { requestAccessCode } from "./data";
import { validateRequestAccess } from "./lib";

interface ConnectedAccessGarageProps extends RouteComponentProps {
    accountSlug: string;
    updateAccessRequest: (request: GarageRequestAccess) => void;
}

export interface AccessGarageState {
    errorMessage: string;
    garageKey: { [key in GarageKeyType]: string };
    garageKeyType: GarageKeyType;
    isNew: boolean;
}

const withState = (WrappedComponent: ComponentType<AccessGarageProps & AccessGarageState>) => {
    class AccessGarageComponent extends Component<ConnectedAccessGarageProps & WithTranslation, AccessGarageState> {
        constructor(props: ConnectedAccessGarageProps & WithTranslation) {
            super(props);
            this.state = {
                errorMessage: "",
                garageKey: {
                    email: "",
                    phone: "",
                },
                garageKeyType: GarageKeyType.phone,
                isNew: false,
            } as AccessGarageState;
        }

        public render() {
            const props = {
                ...this.props,
                ...this.state,
                onSuccess: this.onSuccess,
                requestAccess: this.requestAccess,
                updateGarageKey: this.updateGarageKey,
                updateGarageKeyType: this.updateGarageKeyType,
            };

            return <WrappedComponent {...props} />;
        }

        private updateGarageKeyType = (garageKeyType: GarageKeyType) => {
            this.setState({ garageKeyType });
        };

        private updateGarageKey = (garageKeyType: GarageKeyType, key: string) => {
            this.setState({ garageKey: { ...this.state.garageKey, [garageKeyType]: key } });
        };

        private onSuccess = () => {
            this.props.history.push("/unlock-garage", { from: this.props.location.pathname });
        };

        private requestAccess = async () => {
            const { t } = this.props;
            const { garageKey, garageKeyType, isNew } = this.state;
            const selectedGarageKey = garageKey[garageKeyType];

            const validation = validateRequestAccess({ ...this.state, garageKey: selectedGarageKey });
            if (!validation.isValid) {
                console.error("ERROR!", validation.errorMessage);
                this.setState({
                    errorMessage: validation.errorMessage,
                });
                return false;
            }

            try {
                await requestAccessCode(garageKeyType, this.props.accountSlug, selectedGarageKey);
                this.props.updateAccessRequest({
                    garageKey: selectedGarageKey,
                    garageKeyType,
                    isNew,
                });
                this.setState({
                    errorMessage: "",
                });
                return true;
            } catch (e) {
                console.error("ERROR", e);
                this.setState({
                    errorMessage: t("UserAccount.AccessGarage.genericErrorMessage"),
                });
                return false;
            }
        };
    }

    return withTranslation()(AccessGarageComponent);
};

export default withState(AccessGarage);
